import * as Yup from "yup";
import { format, subYears } from "date-fns";

export const DisputeRvSchema = Yup.object().shape({
  email: Yup.string().required().email("Invalid email"),
  phone: Yup.string()
    .required("phone number is required"),
  affirmation: Yup.boolean().oneOf([true], "Please check the given field"),
});
